import { useGrowthBook } from '@growthbook/growthbook-react'
import React, { useEffect } from 'react'
import { useEffectEvent } from 'use-effect-event'

import { useApis } from '@/legacy-src/contexts/api-context'
import { useAuthenticatedUser } from '@/legacy-src/hooks/useAuthenticatedUser'
import {
  clearExperimentSessionData,
  getExperimentSessionData,
  trackExperiment,
} from '@/legacy-src/lib/growthbook/utilities'

const GrowthBookAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const gb = useGrowthBook()
  const { user, companyId } = useAuthenticatedUser()

  const { api } = useApis()

  const userId = user.id
  const hasSubscription = (user.userSubscriptions?.length ?? 0) > 0
  const registrationTimestamp = user.registrationTimestamp
  const firstEventBookedTimestamp = user.firstEventBookedTimestamp
  const newSubscriptionFlowTriggered = user.newSubscriptionFlowTriggered

  const handleUserChange = useEffectEvent(() => {
    gb.updateAttributes({
      id: userId,
      loggedIn: true,
      hasSubscription,
      registrationTimestamp,
      firstEventBookedTimestamp,
      newSubscriptionFlowTriggered,
    })

    if (companyId !== null) {
      gb.updateAttributes({
        companyId,
      })
    }
  })

  useEffect(() => {
    handleUserChange()
  }, [
    userId,
    companyId,
    hasSubscription,
    registrationTimestamp,
    firstEventBookedTimestamp,
    newSubscriptionFlowTriggered,
  ])

  useEffect(() => {
    const sessionData = getExperimentSessionData()
    if (sessionData) {
      for (const experimentData of sessionData) {
        if (experimentData?.experimentId && experimentData?.experimentVersion)
          trackExperiment(api, experimentData.experimentId, experimentData.experimentVersion)
      }
      clearExperimentSessionData()
    }
  }, [])

  return <>{children}</>
}

export default GrowthBookAuth
